/**
 * @generated SignedSource<<c95ba645745c5f48ffad9c6f2f967b2d>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type JobEventAgentDisconnected_event$fragmentType: FragmentType;
export type JobEventAgentDisconnected_event$data = {|
  +timestamp: any,
  +$fragmentType: JobEventAgentDisconnected_event$fragmentType,
|};
export type JobEventAgentDisconnected_event$key = {
  +$data?: JobEventAgentDisconnected_event$data,
  +$fragmentSpreads: JobEventAgentDisconnected_event$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventAgentDisconnected_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};

(node/*: any*/).hash = "7b4d15a17b0f8191e66e4fd9cce00bfa";

module.exports = ((node/*: any*/)/*: Fragment<
  JobEventAgentDisconnected_event$fragmentType,
  JobEventAgentDisconnected_event$data,
>*/);
